import type { AppState } from 'types/app';

export const selectAccount = (state: AppState) => state.account;

export const selectCustomerInfo = (state: AppState) => selectAccount(state).customerInfo;

export const selectCustomerEmailAddress = (state: AppState) => selectCustomerInfo(state)?.email;
